<template>
	<Default v-if="canRender">
		<router-view></router-view>
	</Default>
	<Loader v-else/>
</template>

<script>
import Default from './layouts/Default.vue';
import Loader from './components/Loader.vue';

export default {
	name: 'App',

	data: function () {
		return {
			canRender: false,
		}
	},

	components: {
		Default,
		Loader
	},

	mounted: function () {
		this.$store.dispatch('GET_TRANSLATES').then(() => {
			this.canRender = true;
		});
	}
}
</script>

<style lang="scss">
	@import "sass/index";
</style>
